/* eslint-disable no-unused-vars */
import * as ScrollMagic from 'scrollmagic';
import { TweenMax, Sine, TimelineMax } from 'gsap/all';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

export default {
  init() {
    // JavaScript to be fired on all pages
    /*
    * In this Codepen there are two functions wrapper in an object.
    *
    * (directAnimations)
    * The first one takes care of animating objects "as soon as" they hit their trigger on the page.
    * These elements animate indipendently from each other as they are not inserted in any timeline.
    *
    * (timelineAnimations)
    * The latter looks for elements that share a timeline in common and adds them in a queue/timeline.
    *
    * Both methods look for elements on the page that have the "data-animation-type" attribute.
    * The whole retrieval of information happens through data attributes to be fair, and it fallbacks to default values when it does not find them.
    */


    var UTIL = {
      directAnimations: function (controller, elements) {
          var $elems = (elements) ? elements : $('[data-animation-type=\'fade-in\']');

          $elems.each(function (index, elem) {       //retrieval of all the elements
              var $elem = $(elem),
                  elemData = $elem.data(),
                  options = $.extend({               //we get the options from the element, if not we fallback on our values
                      'loglevel': 0,
                      'speed': 0.67,
                      'ease': Sine.easeOut,
                      'delay': 0,
                      'animationDirection': 'up',
                      'triggerHook': '0.82',
                      'offset': 0,
                      'reverse': false,
                      'x': 0,
                      'y': 0,
                  }, elemData);

              switch (options.animationDirection) {  //we detect the type of animation we want to run on this element
                  case 'right':
                      options.x = -50;
                      options.y = 0;
                      break;
                  case 'down':
                      options.x = 0;
                      options.y = -50;
                      break;
                  case 'left':
                      options.x = 50;
                      options.y = 0;
                      break;
                  case 'up':
                  default:
                      options.x = 0;
                      options.y = 50;
                      options['offset'] -= 50;
                      break;
              }


              var tween = TweenMax                   //our tween/animation
                      .fromTo(elem, options.speed,
                          {
                              x: options.x,
                              y: options.y,
                              autoAlpha: 0,
                              ease: options.ease,
                          }, {
                              x: 0,
                              y: 0,
                              autoAlpha: 1,
                              ease: options.ease,
                              delay: options.delay,
                          }),
                  scene = new ScrollMagic.Scene({     //finally we rig in the point where scrollMagic will activate the animation
                      triggerElement: $elem.get(0),
                      triggerHook: options['triggerHook'],
                      offset: options['offset'],
                      reverse: options['reverse'],
                  })
                      .setTween(tween)
                      // .addIndicators({'name': 'Direct Animation'})
                      .addTo(controller);
          });
      },
      animationTimelines: function (controller, tls, elements) {
          // we retrieve all the different timelines values in the page
          var $elems = (elements) ? elements : $('[data-timeline]');

          $elems.each(function (index, elem) {
              var timelineValue = $(elem).data('timeline');
              if (tls.hasOwnProperty(timelineValue)) {
                  tls[timelineValue].push($(elem));
              } else {
                  tls[timelineValue] = [];
                  tls[timelineValue].push($(elem));
              }
          });

          // for each one of them, we loop through the elements and we create a new timeline
          // and we add animation to it according to the element data
          for (var timelineValue in tls) {
              var tl = new TimelineMax();

              $elems.filter('[data-timeline=\'' + timelineValue + '\']').each(function (index, elem) {
                  var $elem = $(elem);
                  if ($elem.data('animationType')) {
                      switch ($elem.data('animationType')) {
                          case 'title-composer' :
                              titleComposerAnimation($elem, tl, index);
                              break;

                          case 'staggered-fade-in' :
                              staggeredFadeInAnimation($elem, tl, index);
                              break;

                          case 'timeline-fade-in' :
                              fadeInAnimation($elem, tl, index);
                              break;

                          case 'top-background-slide-in':   // used on single service
                              topBackgroundSlideIn($elem, tl, index);
                              break;

                          case 'left-background-slide-in':  // used on case study listing
                              leftBackgroundSlideIn($elem, tl, index);
                              break;

                          case 'right-background-slide-in': // used on single case study
                              rightBackgroundSlideIn($elem, tl, index);
                              break;

                          case 'face-grid': // used on culture page
                              flipFace($elem, tl, index);
                              break;
                      }
                  }
              });


              // we find the element related to this timeline that has a data of timelineInit
              var triggeringElement = tls[timelineValue].filter(function (element, index) {
                  return $(element).data('timelineInit');
              });

              // if there is no element like that, we get just the first element in the array
              if (triggeringElement.length === 0) {
                  triggeringElement = tls[timelineValue];
              }

              // we create a scene using the options created
              var elemData = triggeringElement[0].data(),
                  options = $.extend({
                      loglevel: 0,
                      triggerElement: triggeringElement[0].get(0),
                      triggerHook: 0.78,
                      offset: 0,
                      reverse: false,
                  }, elemData),
                  scene = new ScrollMagic.Scene(options)
                      .setTween(tl)
                      // .addIndicators({'name': 'Timeline Animations'})
                      .addTo(controller);


              $(window).on('destroy-animation-timelines', function () {
                  scene.destroy(true);
                  controller.destroy(true)
              });
          }

          function titleComposerAnimation(elem, tl, index) {
              var elemData = elem.data(),
                  options = $.extend({
                      'loglevel': 0,
                      'speed': 0.56,
                      'staggerValue': '-=0.25',
                      'ease': Sine.easeOut,
                  }, elemData),
                  spans = elem.find('span');

              /* we call immediately the mobile version as it needs to run asynchronously from the rest */
              tl.add(function () {
                      TweenMax.fromTo(elem.find('.mobile-tag'), options.speed,
                          {
                              x: 50,
                              autoAlpha: 0,
                              ease: options.ease,
                          }, {
                              x: 0,
                              autoAlpha: 1,
                              ease: options.ease,
                          });
                  }
              );

              /* we animate the desktop version */
              spans.each(function (index, elem) {
                  var delay = (index == 0) ? '+=0' : options.staggerValue;
                  tl
                      .fromTo(elem, options.speed,
                          {
                              x: 50,
                              autoAlpha: 0,
                              ease: options.ease,
                          }, {
                              x: 0,
                              autoAlpha: 1,
                              ease: options.ease,
                          }, delay);
              });
          }

          function staggeredFadeInAnimation(elem, tl, index) {
              var elemData = elem.data(),
                  options = $.extend({
                      'loglevel': 0,
                      'speed': 0.67,
                      'ease': Sine.easeOut,
                      'delay': (index > 0) ? '-=0.34' : '+=0',
                  }, elemData);

              tl
                  .fromTo(elem, options.speed,
                      {
                          x: '+=50',
                          autoAlpha: 0,
                          ease: options.ease,
                      }, {
                          x: '-=50',
                          autoAlpha: 1,
                          ease: options.ease,
                      }, options.delay);
          }

          function fadeInAnimation(elem, tl, index) {
              var elemData = elem.data(),
                  options = $.extend({
                      'loglevel': 0,
                      'speed': 0.67,
                      'ease': Sine.easeOut,
                      'delay': '+=0',
                      'animationDirection': 'up',
                      'x': 0,
                      'y': 0,
                  }, elemData);

              switch (options.animationDirection) {
                  case 'right':
                      options.x = 50;
                      options.y = 0;
                      break;
                  case 'down':
                      options.x = 0;
                      options.y = -50;
                      break;
                  case 'left':
                      options.x = -50;
                      options.y = 0;
                      break;
                  case 'up':
                  default:
                      options.x = 0;
                      options.y = 50;
                      break;
              }

              tl
                  .fromTo(elem, options.speed,
                      {
                          x: options.x,
                          y: options.y,
                          autoAlpha: 0,
                          ease: options.ease,
                      }, {
                          x: 0,
                          y: 0,
                          autoAlpha: 1,
                          ease: options.ease,
                      }, options.delay);
          }

          function topBackgroundSlideIn(elem, tl, index) {
              var elemData = elem.data(),
                  options = $.extend({
                      'loglevel': 0,
                      'speed': 1.05,
                      'ease': Sine.easeOut,
                      'delay': '+=0',
                      'top': '-100%',
                      'height': '200%',
                  }, elemData);

              tl
                  .fromTo(elem, options.speed,
                      {
                          top: options.top,
                          height: options.height,
                          x: '0%',
                          y: '-100%',
                          autoAlpha: 0,
                          ease: options.ease,
                      }, {
                          x: '0%',
                          y: '0%',
                          autoAlpha: 1,
                          ease: options.ease,
                      }, options.delay);
          }

          function leftBackgroundSlideIn(elem, tl, index) {
              var elemData = elem.data(),
                  options = $.extend({
                      'loglevel': 0,
                      'speed': 1.05,
                      'ease': Sine.easeOut,
                      'delay': '+=0',
                      'x': '-100%',
                      'y': '-350',
                  }, elemData);

              tl
                  .fromTo(elem, options.speed,
                      {
                          x: options.x,
                          y: options.y,
                          autoAlpha: 0,
                          ease: options.ease,
                      }, {
                          x: '0%',
                          y: '0%',
                          autoAlpha: 1,
                          ease: options.ease,
                      }, options.delay);
          }

          function rightBackgroundSlideIn(elem, tl, index) {
              var elemData = elem.data(),
                  options = $.extend({
                      'loglevel': 0,
                      'speed': 1.05,
                      'ease': Sine.easeOut,
                      'delay': '+=0',
                      'x': '0%',
                      'y': '0',
                  }, elemData);

              tl
                  .fromTo(elem, options.speed,
                      {
                          x: options.x,
                          y: options.y,
                          autoAlpha: 1,
                          ease: options.ease,
                      }, {
                          x: '-=600%',
                          y: '0',
                          autoAlpha: 1,
                          ease: options.ease,
                      }, options.delay);
          }

          function flipFace(elem, tl, index) {
              var elemData = elem.data(),
                  options = $.extend({
                      'loglevel': 0,
                      'speed': 0.56,
                      'ease': Sine.easeOut,
                      'delay': '-=0.48',
                      'x': '0%',
                      'y': '0',
                  }, elemData);

              tl
                  .fromTo(elem, options.speed, {
                      autoAlpha: 0,
                      rotationX: 180,
                      transformOrigin: 'center center',
                  }, {
                      autoAlpha: 1,
                      rotationX: 0,
                      transformOrigin: 'center center',
                  }, options.delay);
          }
      },
    };

    var directController = new ScrollMagic.Controller();
    UTIL.directAnimations(directController);

    var timelinesController = new ScrollMagic.Controller(),
        tls = {};
    UTIL.animationTimelines(timelinesController, tls);
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/common/animation.js